import { render, staticRenderFns } from "./QiangLiJuCaiLabelV2Dialog.vue?vue&type=template&id=0fd8524f&scoped=true"
import script from "./QiangLiJuCaiLabelV2Dialog.vue?vue&type=script&lang=js"
export * from "./QiangLiJuCaiLabelV2Dialog.vue?vue&type=script&lang=js"
import style0 from "./QiangLiJuCaiLabelV2Dialog.vue?vue&type=style&index=0&id=0fd8524f&prod&scoped=true&lang=css"
import style1 from "./QiangLiJuCaiLabelV2Dialog.vue?vue&type=style&index=1&id=0fd8524f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8524f",
  null
  
)

export default component.exports